import { List } from "models/list";
import { doGet, parseListPath } from "../request";
import { ListInvitation } from "models/list-invitation";

export const adminDoGetListUserInvitations = async (
  list: List,
  listUserUuid: string,
) => {
  const emails = await doGet<ListInvitation[]>(
    parseListPath(list, `user/${listUserUuid}/invitations`),
  );
  return emails;
};
